import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const getParishAndCityContext = React.createContext({});
export let getParishAndCityMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMGetParishAndCityGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getParishAndCityMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(getParishAndCityMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    getParishAndCityMachine,
    getParishAndCityState: state,
    getParishAndCitySend: send,
  };
};
